import {Injectable} from '@angular/core';
import {EnvironmentService} from '../environment.service';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class NotificationsApiService {
  constructor(
    private env: EnvironmentService,
    private http: HttpClient,
  ) {}

  getGeneralAnnouncements(params?: {page: number; limit: number}): Observable<any> {
    let url: string;

    if (params) {
      url = `${this.env.apiUrl.apiBase}user-notifications/v0/public/general-announcements?page=${params.page}&limit=${params.limit}`;
    } else {
      url = `${this.env.apiUrl.apiBase}user-notifications/v0/public/general-announcements`;
    }

    return this.http.get(url);
  }

  getPersonalNotifications(ssoUserId: string) {
    return this.http.get(`${this.env.apiUrl.apiBase}user-notifications/v0/user/${ssoUserId}/personal/`);
  }

  readNotification(ssoUserId: string, {notificationId, status}: {notificationId: string; status: string}) {
    return this.http.patch(
      `${this.env.apiUrl.apiBase}user-notifications/v0/user/${ssoUserId}/personal/${notificationId}/status`,
      {status},
    );
  }

  readAllNotifications(ssoUserId: string, data: {ids: string[]; status: string}) {
    return this.http.patch(`${this.env.apiUrl.apiBase}user-notifications/v0/user/${ssoUserId}/personal/readAll`, data);
  }
}
